export const INCIDE_SCRIPT_SRC = "https://cdn.incide.offleash.xyz/w.js";
export const INCIDE_SITE_ID = "pk_MDfGJfiLNJ";

/** Incide is enabled only on deployed, explicitly named pre-production envs. */
export function shouldLoadIncide(
  environment: string | undefined,
  hostname: string,
): boolean {
  const normalizedEnvironment = environment?.trim().toLowerCase();
  const normalizedHostname = hostname.trim().toLowerCase();

  if (!normalizedEnvironment) return false;
  if (["prod", "production"].includes(normalizedEnvironment)) return false;

  return !(
    normalizedHostname === "localhost" ||
    normalizedHostname === "127.0.0.1" ||
    normalizedHostname === "0.0.0.0" ||
    normalizedHostname === "::1" ||
    normalizedHostname.endsWith(".local")
  );
}
